import type { Dto, PasswordValidationResult } from '@/core/interfaceCoreInitial'
import { uuid } from 'vue-uuid';

export default function validate() {
    const longitud = (valor: string, permiteVacio: number, minimo: number, maximo: number, msg: string) => {
        if (valor === null) valor = "";
        const cantCar: number = valor.length;
        if (valor === "") {
            if (permiteVacio) return { validate: true, class: "is-valid", required: msg, bool: true };
            else return { validate: false, class: "is-invalid", required: msg, bool: false };
        } else {
            if (cantCar >= minimo && cantCar <= maximo) return { validate: true, class: "is-valid", required: msg, bool: true };
            else return { validate: false, class: "is-invalid", required: msg, bool: false };
        }
    }

    const email = (email: string, msj: string) => {
        const validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
        if (validEmail.test(email)) {
            return { validate: true, class: "is-valid", required: msj, bool: true };
        } else {
            return { validate: false, class: "is-invalid", required: msj, bool: false };
        }
    }

    const ips = (ip: string, msj: string) => {
        const verdad = ip.split('.');
        if (verdad.length != 4)
            return { validate: false, class: "is-invalid", required: msj, bool: false };
        for (const i in verdad) {
            if (!/^\d+$/g.test(verdad[i])
                || +verdad[i] > 255
                || +verdad[i] < 0
                || /^[0][0-9]{1,2}/.test(verdad[i]))
                return { validate: false, class: "is-invalid", required: msj, bool: false };
        }
        return { validate: true, class: "is-valid", required: msj, bool: true };
    }

    const phones = (phone: string, msg: string) => {
        const validPhone = phone.replace('(', '').replace(' (', '').replace(') ', '').replace('-', '').replace(' ', '');
        if (validPhone.length === 10 || validPhone.length === 13) {
            return { validate: true, class: "is-valid", required: msg, bool: true };
        } else {
            return { validate: false, class: "is-invalid", required: msg, bool: false };
        }
    }

    const checkpassword = (password: string) => {
        let strength = 0;
        let tips = "";

        // Check password length
        if (password.length < 8) {
            tips += "Make the password longer. ";
            return { validate: false, class: "is-invalid", required: "Password is requered minimum 8 characters. " + tips, bool: false };
        } else {
            strength += 1;
        }

        // Check for mixed case
        if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
            strength += 1;
        } else {
            tips += "Use both lowercase and uppercase letters. ";
        }

        // Check for numbers
        if (password.match(/\d/)) {
            strength += 1;
        } else {
            tips += "Include at least one number. ";
        }

        // Check for special characters
        if (password.match(/[^a-zA-Z\d]/)) {
            strength += 1;
        } else {
            tips += "Include at least one special character. ";
        }

        // Return results
        if (strength === 0) {
            return { validate: false, class: "is-invalid", required: "Password is requered minimum 8 characters. " + tips, bool: false };
        } else if (strength === 1) {
            return { validate: false, class: "is-invalid", required: "Easy difficulty. " + tips, bool: false };
        } else if (strength === 2) {
            return { validate: false, class: "is-invalid", required: "Medium difficulty. " + tips, bool: false };
        } else if (strength === 3) {
            return { validate: false, class: "is-warning", required: "Difficult. " + tips, bool: false };
        } else if (strength === 4) {
            return { validate: true, class: "is-valid", required: "Extremely difficult. " + tips, bool: true };
        }
    }

    const confirmpassword = (password: string, confirmpass: string): PasswordValidationResult => {
        if (password.length === 0 && confirmpass.length === 0) {
            return { validate: false, class: "is-invalid", required: "check passwords, Make the password longer.", bool: false };
        } else if (password.length > 7 && confirmpass.length > 7 && password === confirmpass) {
            return { validate: true, class: "is-valid", required: "", bool: true };
        } else {
            return { validate: false, class: "is-invalid", required: "check passwords, they do not match.", bool: false };
        }
    }

    const valiDtoSend = (dto: Dto): boolean => {
        let i = 0;
        for (const propName in dto) {
            if (Object.prototype.hasOwnProperty.call(dto, propName)) {
                if (!dto[propName].validate) {
                    i++;
                    dto[propName].class = "is-invalid";
                    dto[propName].bool = false;
                }
            }
        }
        return i === 0;
    }

    const resetIsError = (dto: Dto) => {

        for (const propName in dto) {
            if (Object.prototype.hasOwnProperty.call(dto, propName)) {
                dto[propName].validate = false;
                dto[propName].bool = true;
            }
        }
    }

    const compareArray = (arr1: [string], arr2: string) => {
        return arr1.filter((elemento: string) => arr2.indexOf(elemento) == -1);
    }

    const generateRandomString = (longitud: number) => {
        const banco = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let random = "";
        for (let i = 0; i < longitud; i++) {
            random += banco.charAt(Math.floor(Math.random() * banco.length));
        }
        return random;
    }

    const generateUUID = () => {
        const genUUID = uuid.v4();
        return genUUID.toUpperCase();     
    }
    
    const getFormattedDate = (
        days = 0,
        formatShort: boolean = true,//true fecha corta yyyy-MM-dd , false fecha larga yyyy-MM-dd HH:mm:ss
        baseDate?:  Date | string
    ): string => {
        const date = baseDate ? new Date(baseDate) : new Date();
        date.setDate(date.getDate() - days);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        if (formatShort) {
            return `${year}-${month}-${day}`;
        } else {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    };
    
    return {
        longitud, email, ips, phones, checkpassword,
        confirmpassword, valiDtoSend, resetIsError,
        compareArray, generateRandomString, generateUUID,
        getFormattedDate
    }
}
